import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsStatusChangesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Status Changes</div>
          <div className="text">
            Posts can be assigned a status: open, under review, planned, in progress, complete,
            or&nbsp;closed.
          </div>
          <div className="text">
            Our API allows you to list status changes, sorted by&nbsp;recency.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
